import Http from "./http-service";

import { PRIVATE_API_ROUTES } from "../constants";
import {
  getTotalAuditVsCompleteAudit,
  getGradingGraph,
  getCountLevel,
} from "../globalContext/dashboard/dashboardActions";
import { showNotification } from "../UtilityFunctions/notification";
import {
  downloadReports,
  getLocalizedMessage,
} from "../UtilityFunctions/utils";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";
import { BAD_REQUEST } from "../constants/errorConstants";

class DashboardService {
  static async getTotalAuditVsCompleteAuditData({ dispatch, params, intl }) {
    dispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.TOTAL_AUDIT_VS_COMPLETE_AUDIT}`,
      params
    )
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(getTotalAuditVsCompleteAudit(res?.data?.data));
        return Promise.resolve(res?.data?.data?.result?.[0]);
      })
      .catch((error) => {
        if (error?.response?.data?.code !== BAD_REQUEST) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        dispatch(setLoading(false));
        return Promise.reject(error);
      });
  }

  static async getGradingGraph({ dispatch, params, intl }) {
    dispatch(setLoading(true));
    return Http.get(`${PRIVATE_API_ROUTES.GRADING_GRAPH}`, params)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(getGradingGraph(res?.data?.data));
        return Promise.resolve(res?.data?.data?.result?.[0]);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        if (error?.response?.data?.code !== BAD_REQUEST) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        return Promise.reject(error);
      });
  }

  static async getCountLevelApiCall({ dispatch, params, intl }) {
    dispatch(setLoading(true));
    return Http.get(`${PRIVATE_API_ROUTES.COUNT_LEVEL}`, params)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(getCountLevel(res?.data?.data));
        return Promise.resolve(res?.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err?.response?.data?.code !== BAD_REQUEST) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
        return Promise.reject(err);
      });
  }

  static async dashboardDownloadReportApiCall({
    loaderDispatch,
    params,
    intl,
  }) {
    loaderDispatch(setLoading(true));
    return Http.get(
      `${PRIVATE_API_ROUTES.DOWNLOAD_DASHBOARD_REPORT}`,
      params,
      () => {}, //NOSONAR
      "blob"
    )
      .then((res) => {
        loaderDispatch(setLoading(false));
        downloadReports(res);
      })
      .catch((error) => {
        loaderDispatch(setLoading(false));
        if (error?.response?.status === 404) {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.dataNotFound")
          );
        } else {
          showNotification(
            "error",
            "Error",
            getLocalizedMessage(intl, "error.somethingWentWrong")
          );
        }
      });
  }
}

export default DashboardService;
